__turbopack_context__.v({
  "Cont": "Logos-module-sass-module__oMuSEG__Cont",
  "Controls": "Logos-module-sass-module__oMuSEG__Controls",
  "Info": "Logos-module-sass-module__oMuSEG__Info",
  "Logo": "Logos-module-sass-module__oMuSEG__Logo",
  "LogoGrid": "Logos-module-sass-module__oMuSEG__LogoGrid",
  "Logos": "Logos-module-sass-module__oMuSEG__Logos",
  "Testimonial": "Logos-module-sass-module__oMuSEG__Testimonial",
  "Testimonials": "Logos-module-sass-module__oMuSEG__Testimonials",
  "fadeIn": "Logos-module-sass-module__oMuSEG__fadeIn",
});
